import { render, staticRenderFns } from "./TransactionReceiptTemplate.vue?vue&type=template&id=7019aea3&scoped=true"
import script from "./TransactionReceiptTemplate.vue?vue&type=script&lang=js"
export * from "./TransactionReceiptTemplate.vue?vue&type=script&lang=js"
import style0 from "./TransactionReceiptTemplate.vue?vue&type=style&index=0&id=7019aea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7019aea3",
  null
  
)

export default component.exports